// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'

import { TrackingProvider } from '@indeed/flex-tracking-context'

import EmployerVenueDetail from 'syft-acp-core/entities/EmployerDetail/EmployerVenueDetail'
import SubNavigation from 'syft-acp-core/components/Navigation/SubNavigation'
import PageTitle, { recordLabel, useEmployerName } from 'syft-acp-core/components/PageTitle'

const EmployerVenueNew = ({ match: { params } }) => {
  const employerName = useEmployerName(Number(params.id))

  return (
    <TrackingProvider
      value={{
        context: {
          employer_id: Number(params.id),
        },
      }}
    >
      <PageTitle title={['New venue', recordLabel('Employer', params.id, employerName)]}>
        <SubNavigation subPage="employers" data={{ employerID: Number(params.id) }} />
        <EmployerVenueDetail id={0} employerID={Number(params.id)} />
      </PageTitle>
    </TrackingProvider>
  )
}

EmployerVenueNew.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      // Note: ID gets passed as a string directly from the URL.
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
}

export default EmployerVenueNew
